<div class="grafico-linha-card">
  <div class="card-header">
    <h3 class="section-title">
      <i class="pi pi-chart-line"></i>
      {{ texts.estatistica_financeira_anual }}
    </h3>
  </div>

  <!-- Legenda customizada + seletor de ano -->
  <div class="legenda-row">
    <div class="legenda-items">
      <span class="item-legenda">
        <span class="dot azul"></span>
        {{ texts.vendas_e_entradas }}
      </span>
      <span class="item-legenda">
        <span class="dot cinza"></span>
        {{ texts.compras_e_gastos }}
      </span>
    </div>
    <p-dropdown
      [options]="anos"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="anoSelecionado"
      (onChange)="onAnoChange($event)"
      styleClass="ano-dropdown">
    </p-dropdown>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="loading-container">
    <p-progressSpinner [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>
  </div>

  <!-- Grafico -->
  <div class="chart-container" *ngIf="!loading">
    <p-chart type="line" [data]="chartData" [options]="chartOptions"></p-chart>
  </div>
</div>
